import { Injectable } from '@angular/core';
import * as ConfigData from '../../../assets/config.json';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs';

/* import { AuthenticodeService } from 'src/app/services/authenticode.service';
import { OvscApiService } from 'src/app/services/ovscapi.service'; 
import { ServiceInjector } from 'src/app/em-common/services/service-injector.module';*/
import { IConfigData } from '../models/configData';
import { MessageService } from '../services/message.service ';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigDataClass {

  public static configData: IConfigData = ConfigData;
  public static dateFormat:string;
  public static getLocalization() {

    return localStorage.getItem('lang')!==null?localStorage.getItem('lang'):'de';

  }
  public static getDateLocalization():string {
   
    
    return   localStorage.getItem('dateFormat')!==null?localStorage.getItem('dateFormat'):'dd.MM.yyyy';;

  }
  constructor(private httpClient: HttpClient, private messageService: MessageService,public translate: TranslateService,) {
     this.initialize();
     
     let dateFormat: string = "";
    this.translate.get("date").subscribe((data: any) => {
      dateFormat = data;
      localStorage.setItem('dateFormat',dateFormat);
    });
   
   
  }
  initialize() {
    return this.httpClient.get<IConfigData>('../../../assets/config.json')
      .pipe(tap((response: IConfigData) => {
        ConfigDataClass.configData = response;
        
        
      })).toPromise();
  }

}





/* function reload1Time() {
  var refresh = window.localStorage.getItem('refresh');         
            setTimeout(function() {
            if (refresh===null){
                window.location.reload();
                window.localStorage.setItem('refresh', "1");
            }
            }, 1500);             
            setTimeout(function() {
            localStorage.removeItem('refresh')
            }, 1700); 
} */

